import api from '../../helpers/api';

import {
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  TRY_LOGIN,
  TRY_LOGIN_SUCCESS,
  TRY_LOGIN_FAILED,
  LOGOUT,
  LOGOUT_SUCCESS,
  SET_EXPIRANDO,
  RENOVAR_TOKEN,
  RENOVAR_TOKEN_SUCCESS,
  RENOVAR_TOKEN_FAILED,
  SET_PERMISOCC,
} from '../types';

import moment from 'moment';

// Actions
const tryLoginAction = (user) => ({
  type: TRY_LOGIN,
  payload: user,
});

const tryLoginFailed = () => ({
  type: TRY_LOGIN_FAILED,
});

const tryLoginSuccess = (data) => ({
  type: TRY_LOGIN_SUCCESS,
  payload: data,
});

const loginSuccessAction = (data) => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

const loginErrorAction = (error) => ({
  type: LOGIN_ERROR,
  payload: error,
});

const logoutAction = () => ({
  type: LOGOUT,
});

const logoutActionSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

const expirandoAction = () => ({
  type: SET_EXPIRANDO,
});

const renovarTokenAction = (data) => ({
  type: RENOVAR_TOKEN,
});

const setPermisoCC = (data) => ({
  type: SET_PERMISOCC,
  payload: data,
});

const renovarTokenSuccessAction = (data) => ({
  type: RENOVAR_TOKEN_SUCCESS,
  payload: data,
});

const renovarTokenFailedAction = (data) => ({
  type: RENOVAR_TOKEN_FAILED,
  payload: data,
});

export const setExpirando = () => {
  return async (dispatch) => {
    dispatch(expirandoAction());
  };
};

export const tryLogin = () => {
  return async (dispatch) => {
    dispatch(tryLoginAction());

    const jsonSession = localStorage.getItem('session');

    if (jsonSession) {
      const session = JSON.parse(jsonSession);
      dispatch(tryLoginSuccess(session));
    } else {
      dispatch(tryLoginFailed());
    }
  };
};

export const login = (user, captcha) => {
  return async (dispatch) => {
    try {
      const response = await api.post('v1/auth/login', {
        dni: parseInt(user.dni),
        nroTramite: parseInt(user.nroTramite),
        captcha,
        sexo: user.sexo,
        ftoken: user.ftoken,
      });

      localStorage.setItem('session', JSON.stringify(response.data));
      localStorage.setItem('lastLogin', moment().unix());

      dispatch(loginSuccessAction(response.data));
    } catch (ex) {
      if (ex.response) {
        dispatch(
          loginErrorAction({
            message: ex.response.data.message,
            // 'Verificá tu Nro de Documento o Nro de Tramite e intentalo nuevamente',
          })
        );
      } else {
        dispatch(
          loginErrorAction({
            message: 'Algo salio mal ',
          })
        );
      }
    }
  };
};

export const renovarSesion = (token) => {
  return async (dispatch) => {
    try {
      dispatch(renovarTokenAction());

      const response = await api.post('v1/auth/renew', null, {
        headers: {
          Authorization: token,
        },
      });

      localStorage.setItem('session', JSON.stringify(response.data));
      localStorage.setItem('lastLogin', moment().unix());

      dispatch(renovarTokenSuccessAction(response.data));
    } catch (ex) {
      if (ex.response) {
        dispatch(
          renovarTokenFailedAction({
            message: 'No se pudo renovar la sesión',
          })
        );
      }
    }
  };
};

export const getPermisoCC = (token) => {
  return async (dispatch) => {
    try {
      const response = await api.get('v1/permiso', {
        headers: {
          Authorization: token,
        },
      });
      dispatch(setPermisoCC(response.data));
    } catch (ex) {
      console.log('Error durante la solicitud de permiso');
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch(logoutAction());
    localStorage.removeItem('session');
    dispatch(logoutActionSuccess());
  };
};
